import { render } from "./YcomLogo.vue?vue&type=template&id=2c8713b2&scoped=true"
import script from "./YcomLogo.vue?vue&type=script&lang=js"
export * from "./YcomLogo.vue?vue&type=script&lang=js"

import "./YcomLogo.vue?vue&type=style&index=0&id=2c8713b2&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8713b2"]])

export default __exports__